import { createFileRoute } from '@tanstack/react-router';

import { FlexibleCalculationTemplateEditPage } from '@/areas/flexible-calculations/FlexibleCalculationTemplates/FlexibleCalculationTemplateEditPage';
import { canViewFlexibleCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

export const Route = createFileRoute(
    '/_authenticated/templates/_sidebar/flexible-calculation/$flexibleCalculationTemplateId',
)({
    staticData: {
        access: { permissions: canViewFlexibleCalculationTemplates },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <FlexibleCalculationTemplateEditPage
                flexibleCalculationTemplateId={pathParams.flexibleCalculationTemplateId}
            />
        </SidebarPageContent>
    );
}
